import title from './title.json';

export default { title };
